import { useLayoutEffect, useRef, useState } from "react";

/**
 * Hook to get the width of an element as it resizes.
 * If placed on a scrollable container, the width will be the visible width only.
 */
export function useElementWidth<TElement extends HTMLElement>() {
  const ref = useRef<TElement | null>(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    const update = () => {
      setWidth(element.clientWidth);
    };

    update();

    const observer = new ResizeObserver(update);
    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return { ref, width };
}
